// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReportBg {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  position: relative;
}
.ReportBg .reportContainer {
  cursor: pointer;
  display: flex;
  padding: 0.6rem 1rem 0.6rem 0.6rem;
  background-color: var(--Foreground);
  align-items: center;
  justify-content: space-between;
  border-radius: 0.6rem;
  width: 100%;
  gap: 1rem;
}
.ReportBg .reportContainer .reportHeading {
  display: flex;
  align-items: center;
  gap: 1.25rem;
}
.ReportBg .reportContainer .reportHeading svg path {
  fill: var(--AccentColor);
}
.ReportBg .reportContainer .reportHeading div {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  max-width: 10rem;
}
.ReportBg .reportContainer .reportHeading div h2 {
  font-size: 0.9rem;
  color: var(--TextColor);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ReportBg .reportContainer .reportHeading div p {
  font-size: 0.8rem;
  color: var(--TextColor);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ReportBg .reportContainer .actions {
  display: flex;
  align-items: center;
  gap: 0.3rem;
}
.ReportBg .reportContainer .actions svg path {
  fill: var(--AccentColor);
}
.ReportBg .reportContainer .reportTopics {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  flex: 1 1;
  padding: 0rem 0.6rem;
  border-right: 1px solid var(--Background);
  border-left: 1px solid var(--Background);
  overflow: hidden;
  white-space: nowrap;
  position: relative;
}
.ReportBg .reportContainer .reportTopics .topicItem {
  background-color: var(--Background);
  border-radius: 0.3rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.75rem;
  white-space: nowrap;
  color: var(--TextColor);
}
.ReportBg .reportContainer .reportTopics .overflowCounter {
  background-color: var(--Foreground);
  padding: 0.3rem 0.5rem;
  position: absolute;
  right: 0;
  width: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 50%;
  transform: translateY(-50%);
  display: none;
}
.ReportBg .reportContainer .reportTopics .overflowCounter span {
  background-color: var(--Background);
  padding: 0.3rem 0.5rem;
  color: var(--TextColor);
  font-size: 0.75rem;
  border-radius: 0.3rem;
}
.ReportBg .reportContainer .reportTopics.overflowing .overflowCounter {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/Components/Report/Report.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;AACJ;AAAI;EACI,eAAA;EACF,aAAA;EACA,kCAAA;EACA,mCAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;EACA,WAAA;EACA,SAAA;AAEN;AAAM;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAER;AACY;EACI,wBAAA;AAChB;AAGQ;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;AADV;AAIU;EACE,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAFZ;AAKU;EACE,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAHZ;AAQM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AANR;AAQY;EACI,wBAAA;AANhB;AAWM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,oBAAA;EACA,yCAAA;EACA,wCAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AATR;AAWQ;EACE,mCAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;AATV;AAYQ;EACE,mCAAA;EACA,sBAAA;EAEA,kBAAA;EACA,QAAA;EACA,aAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;AAZV;AAaU;EACE,mCAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;AAXZ;AAeQ;EACE,cAAA;AAbV","sourcesContent":[".ReportBg {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 0.6rem;\n    position: relative;\n    .reportContainer {\n        cursor: pointer;\n      display: flex;\n      padding: 0.6rem 1rem 0.6rem 0.6rem;\n      background-color: var(--Foreground);\n      align-items: center;\n      justify-content: space-between;\n      border-radius: 0.6rem;\n      width: 100%;\n      gap: 1rem;\n  \n      .reportHeading {\n        display: flex;\n        align-items: center;\n        gap: 1.25rem;\n\n        svg{\n            path{\n                fill: var(--AccentColor);\n            }\n        }\n  \n        div {\n          display: flex;\n          flex-direction: column;\n          gap: 0.3rem;\n          max-width: 10rem;\n\n  \n          h2 {\n            font-size: 0.9rem;\n            color: var(--TextColor);\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n          }\n  \n          p {\n            font-size: 0.8rem;\n            color: var(--TextColor);\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n          }\n        }\n      }\n  \n      .actions {\n        display: flex;\n        align-items: center;\n        gap: 0.3rem;\n        svg{\n            path{\n                fill: var(--AccentColor);\n            }\n        }\n      }\n  \n      .reportTopics {\n        display: flex;\n        align-items: center;\n        gap: 0.3rem;\n        flex: 1;\n        padding: 0rem 0.6rem;\n        border-right: 1px solid var(--Background);\n        border-left: 1px solid var(--Background);\n        overflow: hidden; // Ensures that the overflowing topics are hidden\n        white-space: nowrap;\n        position: relative;\n  \n        .topicItem {\n          background-color: var(--Background);\n          border-radius: 0.3rem;\n          padding: 0.3rem 0.6rem;\n          font-size: 0.75rem;\n          white-space: nowrap;\n          color: var(--TextColor);\n        }\n  \n        .overflowCounter {\n          background-color: var(--Foreground);\n          padding: 0.3rem 0.5rem;\n        //   border-radius: .3rem;\n          position: absolute;\n          right: 0;\n          width: 3.5rem;\n          // height: 140%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          top: 50%;\n          transform: translateY(-50%);\n          display: none;\n          span{\n            background-color: var(--Background);\n            padding: .3rem .5rem;\n            color: var(--TextColor);\n            font-size: 0.75rem;\n            border-radius: .3rem;\n          }\n        }\n  \n        &.overflowing .overflowCounter {\n          display: block;\n        }\n      }\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
